<script lang="ts">

    import { fade } from 'svelte/transition';
    import type { Player } from "../../Model/Player";
    import Watch from "../Watch.svelte";
    import Picture from "./Picture.svelte";

    export let player: Player;

</script>

<div class="player-pill" transition:fade>
    <div class="picture">
        <Picture id={player.pictureId} />
    </div>
    <div class="name">
        <Watch state={player.name} />
    </div>
</div>

<style lang="scss">

    .player-pill {
        display: inline-flex;
        align-items: center;
        gap: .5rem;
        background-color: #333;
        color: #fff;
        border-radius: 1000rem;
        padding: .15rem 1rem .25rem .25rem;
    }

    .picture {
        $size: 2rem;
        width: $size;
        height: $size;
        border-radius: 50%;
        overflow: hidden;
    }

</style>
